import { useNavigate } from 'react-router-dom';

import { Box, Button, Container, Typography } from '@mui/material';

/* =================== ERROR VIEW COMPONENT =================== */

export default function ErrorView() {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/online-payment/dashboard');
    window.location.reload();
  };

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          textAlign: 'center',
          gap: 3,
        }}
      >
        {/* ERROR ICON */}
        <Box
          sx={{
            fontSize: 80,
            color: 'error.main',
          }}
        >
          ⚠️
        </Box>

        {/* ERROR MESSAGE */}
        <Box>
          <Typography variant="h4" gutterBottom sx={{ fontWeight: 600 }}>
            Oops! Something went wrong
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
            We encountered an unexpected error in the payment system. Please try refreshing the page
            or return to the dashboard.
          </Typography>
        </Box>

        {/* ACTION BUTTONS */}
        <Box sx={{ display: 'flex', gap: 2 }}>
          <Button
            variant="contained"
            color="primary"
            size="large"
            onClick={handleGoHome}
            sx={{ minWidth: 150 }}
          >
            Go to Dashboard
          </Button>
          <Button
            variant="outlined"
            color="inherit"
            size="large"
            onClick={() => window.location.reload()}
            sx={{ minWidth: 150 }}
          >
            Reload Page
          </Button>
        </Box>

        {/* HELP TEXT */}
        <Typography variant="caption" color="text.disabled" sx={{ mt: 4 }}>
          If the problem persists, please contact support.
        </Typography>
      </Box>
    </Container>
  );
}
